<template>
    <div class="reason">
        <div class="icon"><img v-bind:src="icon" /></div>
        <div class="title">{{ title }}</div>       
    </div>    
</template>

<script>
export default {
    name: 'Reason',
    props: ['icon', 'title']
}
</script>

<style scoped 
       lang="scss">
    @import "../../static/styles/palette.scss";

    .reason {
        display: flex;
        align-items: center;
        margin: 33px 0;
        width: 350px;

        & .icon {
            display: flex;
            align-items: center;
            width: 55px;
            height: 55px;
            margin-right: 20px;

            & img {
                width: 100%;
                height: auto;
            }
        }

        & .title {
            width: 295px;
            font-family: "Roboto";
            font-weight: 700;
            font-size: 23px;
            letter-spacing: 3px;
        }
    }
    
    @media all and (max-width: 960px) {
        .reason {
            width: 300px;
            margin: 25px 0;

            & .title {
                width: 245px;
                font-size: 20px;
            }
        }
    }

    @media all and (max-width: 480px) {
        .reason {
            width: 220px;
            margin: 20px 0;

            & .icon {
                width: 40px;
                height: 40px;
            }

            & .title {
                width: 160px;
                font-size: 18px;
                letter-spacing: 2px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// Reason.vue?f18cc642